/**
 * @typedef {import('./BlogProps').default} Props
 */
import {
	withBlogService,
	withBlogServiceActivityProxy,
} from 'service-container';
import { withTheme } from 'shared/ThemeProvider';
import { withSettings } from '../shared/SettingProvider/SettingProvider';
import BlogIndex from 'Blog/BlogIndex';
import BlogPost from 'Blog/BlogPost';
import concatPaths from 'utils/contactPaths';
import paths from 'config/local/paths';
import Page from 'shared/Page';
import React from 'react';
import Switch from 'shared/Switch';

const ThemedBlogIndex = withTheme(BlogIndex);
const ThemedBlogPost = withTheme(BlogPost);

/** @extends {React.Component<Props>} */
class Blog extends React.Component {
	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);
		this.rootPath = this.props.match.url;

		this.BlogIndexComponent = this.props.match.url.startsWith(
			paths.app.root
		)
			? withBlogServiceActivityProxy(ThemedBlogIndex)
			: withBlogService(ThemedBlogIndex);
	}

	render() {
		const blogIndexTitle = this.props.theme?.agentName
			? `${this.props.theme.agentName}’s Resource Library`
			: 'Resource Library';

		return (
			<Switch>
				<Page
					component={this.BlogIndexComponent}
					exact
					path={this.rootPath}
					title={blogIndexTitle}
					withContainer={true}
				/>
				<Page
					component={ThemedBlogPost}
					path={concatPaths(this.rootPath, ':slug')}
					title={blogIndexTitle}
					withContainer={true}
				/>
			</Switch>
		);
	}
}

export default withSettings(Blog);
